import { useMutation, useQueryClient } from '@tanstack/react-query'
import axios from 'axios'

import type { Design } from './designs'

export interface EditDesignBody {
  prompt: string
  subjectImageUrls?: string[]
}

export const useEditDesign = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      designId,
      body
    }: {
      designId: string
      body: EditDesignBody
    }) =>
      axios
        .post<Design[]>(`/designs/${designId}/edit`, body)
        .then(({ data }) => data),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['designs'] })
    }
  })
}
